document.querySelectorAll('.product_description').forEach(el => {
  const fullHTML = el.innerHTML;
  const words = el.textContent.trim().split(/\s+/);

  if (words.length > 25) {
    const preview = words.slice(0, 25).join(' ') + '...';

    el.innerHTML = `
      <span class="text-short-preview">${preview}</span>
      <span class="product_read-more">read more</span>
      <div class="text-full" style="display:none">${fullHTML}</div>
    `;

    el.querySelector('.product_read-more').addEventListener('click', () => {
      el.querySelector('.text-short-preview').remove();
      el.querySelector('.product_read-more').remove();
      el.querySelector('.text-full').style.display = '';
    });
  }
});


// Bundle remove: removes parent + all children with the same _bundle_id
// useCapture=true to fire before cart-drawer stops propagation
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.cart-bundle-item__remove[data-bundle-id]');
  if (!btn) return;

  e.preventDefault();
  e.stopImmediatePropagation();
  const bundleId = btn.dataset.bundleId;
  btn.disabled = true;

  try {
    const cartRes = await fetch(window.Shopify.routes.root + 'cart.js');
    const cartData = await cartRes.json();

    const updates = {};
    cartData.items.forEach((item) => {
      if (item.properties && item.properties._bundle_id === bundleId) {
        updates[item.key] = 0;
      }
    });

    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    if (window.location.pathname.endsWith('/cart')) {
      window.location.reload();
    }
  } catch (err) {
    console.error('Bundle remove error:', err);
    btn.disabled = false;
  }
}, true);

document.addEventListener('DOMContentLoaded', () => {
  const inputs = document.querySelectorAll('.quantity-selector__input');

  inputs.forEach(input => {
    const maxQty = parseInt(input.getAttribute('max')) || 10;  

    input.addEventListener('input', () => {
      let val = parseInt(input.value);

      if (isNaN(val) || val < 1) {
        input.value = 1;  
      } else if (val > maxQty) {
        input.value = maxQty;  
      }
    });
  });
});

// Highlight nav items and update collection title by filter params in URL
function syncNavAndTitle() {
  const url = new URL(window.location.href);
  const navLinks = document.querySelectorAll('.header__primary-nav-item a');
  const h1 = document.querySelector('h1[data-collection-title]');
  let matched = false;

  // Reset aria-current on all filter nav links first
  navLinks.forEach(link => {
    try {
      if ([...new URL(link.href).searchParams].length > 0) {
        link.removeAttribute('aria-current');
      }
    } catch (e) {}
  });

  navLinks.forEach(link => {
    try {
      const linkUrl = new URL(link.href);
      if (linkUrl.pathname !== url.pathname) return;
      if ([...linkUrl.searchParams].length === 0) return;

      for (const [key, value] of linkUrl.searchParams) {
        if (url.searchParams.get(key) !== value) return;
      }

      // Match found
      matched = true;
      link.setAttribute('aria-current', 'page');
      if (h1) h1.textContent = link.textContent.trim();

      // Remove aria-current from plain path link
      navLinks.forEach(other => {
        try {
          const otherUrl = new URL(other.href);
          if (other !== link && otherUrl.pathname === url.pathname && [...otherUrl.searchParams].length === 0) {
            other.removeAttribute('aria-current');
          }
        } catch (e) {}
      });
    } catch (e) {}
  });

  // No filter match — restore collection title and plain link aria-current
  if (!matched) {
    if (h1) h1.textContent = h1.dataset.collectionTitle;
    navLinks.forEach(link => {
      try {
        const linkUrl = new URL(link.href);
        if (linkUrl.pathname === url.pathname && [...linkUrl.searchParams].length === 0) {
          link.setAttribute('aria-current', 'page');
        }
      } catch (e) {}
    });
  }
}

syncNavAndTitle();

// Watch for AJAX filter changes (pushState + replaceState + popstate)
['pushState', 'replaceState'].forEach(method => {
  const orig = history[method];
  history[method] = function (...args) {
    orig.apply(this, args);
    syncNavAndTitle();
  };
});
window.addEventListener('popstate', syncNavAndTitle);
